import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown, Icon, Label, Message, Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting.js';
import PropTypes from 'prop-types';
import Modal from 'components/shared/modal/content';
import PopupHeader from 'components/pages/popupHeader';
import { showEditTagValueModal } from 'actions/modal.js';
import { displayGlobalMessage } from 'actions/globalMessage';
import {
  updateAsssignedValuesByTagId,
  getAvailableTagsByNetworkId,
  clearTempAssignTagsObject,
  saveEditTags,
  getWaitingAreaTags,
} from 'actions/waitingArea.js';
import { sortTagValues } from '../../../../businessLogic/sorting.js';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

export default function WaitingAreaEditTagValueContent(props) {
  const dispatch = useDispatch();

  const [savingingEditTagValue, setSavingingEditTagValue] = useState(false);
  const selectedTagObject = useSelector((state) => state.waitingAreaReducer.selectedTagObject);
  const assignTagValuesForm = useSelector((state) => state.waitingAreaReducer.assignTagValuesForm);
  const [availableTagValues, setAvailableTagValues] = useState();
  const [singleSelectionDefaultValue, setSingleSelectionDefaultValue] = useState(
    !!assignTagValuesForm &&
      assignTagValuesForm.canMultiSelect === false &&
      assignTagValuesForm.tagValuesHasBeenSaved.length > 0
      ? assignTagValuesForm.tagValuesHasBeenSaved[0].tagValueId
      : null
  );

  useEffect(() => {
    let availableTagValuesLocal = [];
    if (!!assignTagValuesForm) {
      let hasBeenAssignedTagValueIds = [];
      assignTagValuesForm.tagValuesEdited.map((x) => {
        hasBeenAssignedTagValueIds.push(x.tagValueId);
      });
      if (hasBeenAssignedTagValueIds.length > 0 && assignTagValuesForm.canMultiSelect) {
        selectedTagObject.availableTagValues
          .filter((tagValue) => {
            return !hasBeenAssignedTagValueIds.includes(tagValue.tagValueId);
          })
          .map((remainedTagValue) => {
            availableTagValuesLocal.push({
              key: remainedTagValue.tagValueId,
              text: remainedTagValue.tagValue,
              value: remainedTagValue.tagValueId,
            });
          });
      } else {
        selectedTagObject.availableTagValues.map((remainedTagValue) => {
          availableTagValuesLocal.push({
            key: remainedTagValue.tagValueId,
            text: remainedTagValue.tagValue,
            value: remainedTagValue.tagValueId,
          });
        });
      }
    }
    setAvailableTagValues(availableTagValuesLocal);
  }, [selectedTagObject, assignTagValuesForm]);

  useEffect(() => {
    setSingleSelectionDefaultValue(
      !!assignTagValuesForm &&
        assignTagValuesForm.canMultiSelect === false &&
        assignTagValuesForm.tagValuesHasBeenSaved.length > 0
        ? assignTagValuesForm.tagValuesHasBeenSaved[0].tagValueId
        : null
    );
  }, [assignTagValuesForm]);

  const saveBtnOnClick = () => {
    setSavingingEditTagValue(true);
    let cb = (hideOrNot) => {
      let succesfulMessage =
        assignTagValuesForm.tagValuesEdited.length == 0
          ? APP.LANGUAGE.OrganisationalUnitManageTags.RemoveTagModal.DeleteTagSuccessfulMessage.replace(
              '##tagName##',
              selectedTagObject.tagName
            )
          : APP.LANGUAGE.OrganisationalUnitManageTags.EditTagValueModal.EditTagSuccessfulMessage.replace(
              '##tagName##',
              selectedTagObject.tagName
            );

      let cbAfterGettingTags = () => {
        setSavingingEditTagValue(false);
        dispatch(showEditTagValueModal(hideOrNot));
        if (!hideOrNot) {
          dispatch(clearTempAssignTagsObject());
          dispatch(
            displayGlobalMessage({
              text: succesfulMessage,
              visible: true,
              messageType: APP.LANGUAGE.GlobalMessageTypes.Good,
              autoHide: true,
            })
          );
        }
      };
      dispatch(getAvailableTagsByNetworkId(props.waitingArea.id));
      dispatch(getWaitingAreaTags(props.waitingArea.id, cbAfterGettingTags));
    };
    let editedTagValueIdArray = [];
    let addedValueIdArray = [];
    let removedValueIdArray = [];

    let hasSavedTagValueIdArray = [];
    assignTagValuesForm.tagValuesHasBeenSaved.map((x) => {
      hasSavedTagValueIdArray.push(x.tagValueId);
    });

    assignTagValuesForm.tagValuesEdited.map((selectedTagValue) => {
      if (!hasSavedTagValueIdArray.includes(selectedTagValue.tagValueId)) {
        addedValueIdArray.push(selectedTagValue.tagValueId);
      }
      editedTagValueIdArray.push(selectedTagValue.tagValueId);
    });

    hasSavedTagValueIdArray.map((originallyAssignedTagValue) => {
      if (!editedTagValueIdArray.includes(originallyAssignedTagValue)) {
        removedValueIdArray.push(originallyAssignedTagValue);
      }
    });
    let newEditedTagObject = {
      tagId: selectedTagObject.tagId,
      tagName: selectedTagObject.tagName,
      editTagValues: editedTagValueIdArray,
      addedValues: addedValueIdArray,
      removedValues: removedValueIdArray,
    };
    dispatch(saveEditTags(props.waitingArea.id, newEditedTagObject, cb));
  };

  const cancelEditTagValue = () => {
    dispatch(showEditTagValueModal(false));
    dispatch(clearTempAssignTagsObject());
  };

  const multiSelectTagValueOption = (event, data) => {
    let tagValuesArray = assignTagValuesForm.tagValuesEdited;
    if (!!data.value && event.target.type === undefined) {
      let ifTagValueExists = tagValuesArray.find((x) => {
        return x == data.value;
      });
      if (ifTagValueExists == undefined) {
        tagValuesArray.push({
          tagValueId: data.value,
          tagValue: event.target.textContent,
        });
      }
    }
    let updateTagValuesObject = {
      tagValuesEdited: tagValuesArray,
    };
    dispatch(updateAsssignedValuesByTagId(updateTagValuesObject));
  };

  const singleSelectTagValueOption = (event, data) => {
    if (!!data.value) {
      let updateTagValuesObject = {
        tagValuesEdited: [
          {
            tagValueId: data.value,
            tagValue: event.target.textContent,
          },
        ],
      };

      dispatch(updateAsssignedValuesByTagId(updateTagValuesObject));
    }
  };

  const removeATagValue = (tagValueId) => {
    let tagValuesArray = assignTagValuesForm.tagValuesEdited;
    if (!!tagValueId) {
      let foundIndex = tagValuesArray.findIndex((x) => {
        return x.tagValueId === tagValueId;
      });
      if (foundIndex > -1) {
        tagValuesArray.splice(foundIndex, 1);
        let updateTagValuesObject = {
          tagValuesEdited: tagValuesArray,
        };
        dispatch(updateAsssignedValuesByTagId(updateTagValuesObject));
      }
    }
  };

  const noTagsAssignedWarning = (onMobile) => {
    let warningClass = 'borderless bg-transparent pdlnull pdrnull';
    if (onMobile) {
      warningClass = warningClass + ' color-bad-things-text-on-mobile';
    } else {
      warningClass = warningClass + ' color-bad-things-text';
    }
    return (
      <Message icon className={warningClass}>
        <Icon name="exclamation circle" className="mrrm" />
        <Message.Content>
          <div>
            {htmlToReactParser.parse(
              xss(
                APP.LANGUAGE.WaitingAreaManageTags.EditTagValueModal.ClearAllTagsReminder.replace(
                  '##tagName##',
                  selectedTagObject.tagName
                )
              )
            )}
          </div>
        </Message.Content>
      </Message>
    );
  };

  const btnClasses = 'ui labeled icon button left-text mrbnull mrpcrxs color-white mrlnull max-width';
  const rightPanel = (
    <div>
      <div className="ui actions mrtxxs mrbl max-width">
        <button
          tabIndex="4"
          type="button"
          id="save-btn"
          className={
            savingingEditTagValue
              ? btnClasses + ' color-button color-button-hover loading'
              : btnClasses + ' color-button color-button-hover'
          }
          onClick={saveBtnOnClick}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark icon" />
        </button>
        <button
          tabIndex="5"
          type="button"
          id="cancel-btn"
          onClick={cancelEditTagValue}
          className={btnClasses + ' color-bad-things color-bad-things-hover mrtm'}
        >
          <i className="remove icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
    </div>
  );

  let waitingAreaName = props.waitingArea ? props.waitingArea.name : '';
  let tagName = props.assignTagValuesForm ? props.assignTagValuesForm.tagName : '';
  let subtitle = tagName + ' (' + waitingAreaName + ')';

  let selectedTagValuesLabelMarkup = assignTagValuesForm.canMultiSelect ? (
    <div className="mrtm">
      <Container fluid as={Media} lessThan="computer">
        <div>
          {sortTagValues(assignTagValuesForm.tagValuesEdited).map((tagValue) => {
            return (
              <Label key={tagValue.tagValueId} className="mrbs mrrs">
                <Icon name="tag" className="info-color" />
                <span className="info-color">{tagValue.tagValue}</span>
                <Icon name="delete" className="info-color" onClick={() => removeATagValue(tagValue.tagValueId)} />
              </Label>
            );
          })}
        </div>
        {assignTagValuesForm.tagValuesEdited.length == 0 ? noTagsAssignedWarning(true) : ''}
      </Container>
      <Container fluid as={Media} greaterThanOrEqual="computer">
        <div>
          {sortTagValues(assignTagValuesForm.tagValuesEdited).map((tagValue) => {
            return (
              <Label key={tagValue.tagValueId} className="mrbs mrrs">
                <Icon name="tag" />
                {tagValue.tagValue}
                <Icon name="delete" onClick={() => removeATagValue(tagValue.tagValueId)} />
              </Label>
            );
          })}
        </div>
        {assignTagValuesForm.tagValuesEdited.length == 0 ? (
          <div className="mrtm mrbm">{noTagsAssignedWarning(false)}</div>
        ) : (
          ''
        )}
      </Container>
    </div>
  ) : (
    ''
  );
  return (
    <Modal show={true} hideWhenClickAway={false}>
      <PopupHeader
        helpLink={APP.EXTERNAL_LINKS.ManageTaggings.HelpEditTags}
        title={APP.LANGUAGE.OrganisationalUnitManageTags.EditTagValueModal.Title}
        subtitle={subtitle}
      />
      <div className="content ui form minHeightSmallForm">
        <div className="main-ui-container assign-tags-modal">
          <div id="righthandfloatingpanel">
            <div className="right ui rail">
              <div className="ui sticky">{rightPanel}</div>
            </div>
            <div className="placeholder-label no-bold div-like color-placeholder">
              {APP.LANGUAGE.OrganisationalUnitManageTags.EditTagValueModal.TagValueCaption}
            </div>
            {!!assignTagValuesForm && assignTagValuesForm.canMultiSelect ? (
              !!availableTagValues && availableTagValues.length === 0 ? (
                <Dropdown
                  className="options-dropdown-equal-length"
                  placeholder={APP.LANGUAGE.OrganisationalUnitManageTags.EditTagValueModal.EmptyTagValuePlaceHolder}
                  onChange={multiSelectTagValueOption}
                  fluid
                  search
                  selection
                  value={null}
                  disabled
                  options={availableTagValues}
                />
              ) : (
                <Dropdown
                  className="options-dropdown-equal-length"
                  placeholder={APP.LANGUAGE.OrganisationalUnitManageTags.EditTagValueModal.TagValuePlaceholder}
                  onChange={multiSelectTagValueOption}
                  fluid
                  search
                  selection
                  value={null}
                  options={availableTagValues}
                />
              )
            ) : (
              <Dropdown
                className="options-dropdown-equal-length"
                onChange={singleSelectTagValueOption}
                fluid
                search
                selection
                options={availableTagValues}
                defaultValue={singleSelectionDefaultValue}
              />
            )}
            {selectedTagValuesLabelMarkup}
            <div className="bottom-rail-with-left-and-right-content mrtl">{rightPanel}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

WaitingAreaEditTagValueContent.propTypes = {
  waitingArea: PropTypes.object.isRequired,
  selectedTagObject: PropTypes.object.isRequired, // Tag info for the selected one
  assignTagValuesForm: PropTypes.object, // Payload for editing the selected tag including saved values
  availableTagValues: PropTypes.array, // All available tag values for the selected tag
  singleSelectionDefaultValue: PropTypes.number, // For single-selection tag, returns the saved values
};
